import React from 'react'

const WizardContext = React.createContext<string | number>('')

export default WizardContext
